import {
  contractTypeOptions,
  renewalIndicatorOptions,
} from "@/features/license-fee/list/utils/private-office-contract-mappings";
import { parseMoneyValue } from "@/utils/parse-money";
import { privateOfficeContractsService } from "@/services/private-office-contracts-service";
import { format, startOfMonth } from "date-fns";
import { LoaderFunctionArgs, redirect } from "react-router-dom";

export const loader = async ({ params }: LoaderFunctionArgs) => {
  const { contractId } = params;

  if (!contractId) {
    throw redirect("/");
  }

  const contract =
    await privateOfficeContractsService.getPrivateOfficeContractById(
      Number(contractId),
    );

  if (!contract) {
    throw redirect("/");
  }

  const selectedCompany = {
    value: contract.company.id.toString(),
    label: contract.company.name,
  };

  const selectedSpace = {
    value: contract.space.id.toString(),
    label: contract.space.name,
  };

  const selectedPrivateOffice = contract.spot
    ? {
        value: contract.spot.id.toString(),
        label: contract.spot.label,
        monthlyPrice: contract.spot.monthlyPrice,
      }
    : undefined;

  const acceptanceTermAsset = contract.assets
    .reverse()
    .find((asset) => asset.type === "partner_assignment_term");

  const acceptanceTermFiles = acceptanceTermAsset
    ? {
        id: acceptanceTermAsset.id,
        url: acceptanceTermAsset.url,
        name: acceptanceTermAsset.url.split("/").pop() || "termo_aceite",
      }
    : undefined;

  const knowledgeTermAsset = contract.assets
    .reverse()
    .find((asset) => asset.type === "company_assignment_term");

  const knowledgeTermFiles = knowledgeTermAsset
    ? {
        id: knowledgeTermAsset.id,
        url: knowledgeTermAsset.url,
        name: knowledgeTermAsset.url.split("/").pop() || "termo_conhecimento",
      }
    : undefined;

  const undeterminedTimeValue = !contract.endDate;

  const minStartDate = format(startOfMonth(new Date()), "yyyy-MM-dd");
  const minEndDate = format(startOfMonth(new Date()), "yyyy-MM-dd");

  const contractInitialValues = {
    ...contract,
    partnerValue: parseMoneyValue(Number(contract.partnerPrice)).toString(),
    companyId: contract.company.id.toString(),
    packageId: contract.packageId.toString(),
    coworkingId: contract.space.id.toString(),
    privateOfficeId: contract.spot?.id.toString() ?? undefined,
    startDate: contract.startDate.split("T")[0],
    endDate: contract.endDate?.split("T")[0],
    noticeInDaysClient: contract.noticeInDaysCompany,
    takeRatePercentage: contract.takePercentage,
    contractResponsibleUser: contract.user,
    contractResponsibleUserId: contract?.user?.id.toString(),
    roomResponsibleUser: contract.managerUser,
    roomResponsibleUserId: contract?.managerUser?.id.toString(),
    contractType: contract.type,
    undeterminedTimeValue,
    acceptanceTermFiles,
    knowledgeTermFiles,
  };

  return {
    contractId,
    contractTypeOptions,
    renewalIndicatorOptions,
    contractInitialValues,
    selectedCompany,
    selectedSpace,
    selectedPrivateOffice,
    minStartDate,
    minEndDate,
  };
};

export type LoaderData = Awaited<ReturnType<typeof loader>>;
